import React, { Component } from "react";
import DOMPurify from "dompurify";
import moment from "moment";
import "moment/locale/tr";
import convertLinksToAnchors from "../helpers/convertLinksToAnchors";
moment.locale("tr");
export default class OrderDetailHistory extends Component {
  render() {
    return (
      <table
        className={"table table-bordered table-hover"}
        style={{ marginTop: 10 }}
      >
        <thead>
          <tr>
            <th>İşlem Tarihi</th>
            <th>Durumu</th>
            <th>Açıklama</th>
          </tr>
        </thead>
        <tbody>
          {this.props.order[
            this.props.customer ? "order" : "orderEnquiry"
          ].history.map((history, i) => (
            <tr key={i}>
              <td>{moment(history.created_at).format("DD/MM/YYYY")}</td>
              <td>{history.status}</td>
              <td
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(convertLinksToAnchors(history.comment)),
                }}
              />
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OrderDetailHistory.js